import {commonService} from "./common.services";
export  const pageService = {
    loginUser,
    logoutUser

}

function loginUser(data) {
    return commonService.sendHttpRequest('login/checklogin', data, "POST");
}
function logoutUser(data) {
    return commonService.sendHttpRequest('login/logout', data, "POST");
}


// WEBPACK FOOTER //
// ./src/services/pages.services.js